export default "__VITE_ASSET__ef436474__"